import { createPortal } from 'react-dom';
import { useEffect, useState, type ReactNode } from 'react';

export function ModalPortal({ children }: { children: ReactNode }) {
  const [node, setNode] = useState<Element | null>(null);

  useEffect(() => {
    setNode(document.getElementById('modal-portal-root'));
  }, []);

  if (!node) return null;
  return createPortal(children, node);
}
